import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://lionmagazine-backend-139572186833.asia-southeast1.run.app/api';

const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    // The membership portal sends ?token=BASE64_JSON.TIMESTAMP.SHA256
    const portalToken = searchParams.get('token');
    const next = searchParams.get('next') || '/';

    if (!portalToken) {
      setError('登入失敗：缺少驗證資料，請透過會員系統重新登入。');
      return;
    }

    // Exchange the portal-signed token for a DRF session token
    axios.post(`${API_BASE_URL}/auth/portal-login/`, { token: portalToken })
      .then(({ data }) => {
        localStorage.setItem('auth_token', data.token);
        localStorage.setItem('auth_user', JSON.stringify({
          id: data.id,
          username: data.username,
          email: data.email,
          is_staff: data.is_staff,
          is_superuser: data.is_superuser,
        }));
        navigate(next, { replace: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || '登入失敗，請透過會員系統重新登入。';
        setError(msg);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: '#dc2626' }}>
          <p>{error}</p>
          <a href="https://portal.lionsclubs.org.hk" style={{ color: '#1a3a8f' }}>返回會員系統</a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: '#64748b' }}>登入中，請稍候…</p>
    </div>
  );
};

export default AuthCallbackPage;
